import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent implements OnInit {
  
  constructor(public router: Router,
              public handler: HandlerService,
              public service: AuthService) { }
  login:boolean; start:boolean; reg:boolean; forgot:boolean;orgReg:boolean;  
  admin:boolean;adprovider:boolean;           

  ngOnInit() {
    let url = window.location.href.split('/').pop();
    if(url.includes('register')){
      this.checkFun(false,true,false,false,false,false)
    }
    else if(url.includes('login')){
      this.checkFun(true,false,false,false,false,false)
    }
    else if(url.includes('forget')){
      this.checkFun(false,false,false,true,false,false)
    }
    else if(url.includes('org')) {
      this.checkFun(false,false,false,false,true,false)
    }
    else if(url.includes('admin')){
      this.checkFun(false,false,false,false,false,true)
    }
    else{
      this.checkFun(false,false,true,false,false,false)
    }
    
  }

  checkFun(arg1,arg2,arg3,arg4,arg5,arg6){
    this.login = arg1;
    this.reg = arg2;
    this.adprovider = arg3;
    this.forgot = arg4;
    this.orgReg = arg5;
    this.admin = arg6;
    // this.adprovider = arg7;
  }

}

